import React from "react";

import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { BankIdLoginErrorCodes, LoginErrorResponseModel } from "@data-types";
import { LoginErrorCodes } from "@data-types/user/LoginErrorCodes";

class LoginErrorPropType {
	loginError: LoginErrorResponseModel | null;
}

export default function LoginErrorMessageTemplate(props: LoginErrorPropType) {
	const { t } = useTranslation("login");
	const { loginError } = props;
	if (loginError == null) {
		return null;
	}

	const errorCode = Number(loginError?.errorCode);

	if (
		[
			LoginErrorCodes.CPRNumberNotRegistered,
			LoginErrorCodes.CPRNumberVerificationError,
			LoginErrorCodes.playerTooYoung,
			LoginErrorCodes.spelpausGamingExclusionActive,
			LoginErrorCodes.lugasPlayerNotRegistered,
			LoginErrorCodes.lugasUnspecified,
			LoginErrorCodes.lugasValidationError,
			LoginErrorCodes.lugasDown,
			LoginErrorCodes.loginDisabledLugasDown,
			LoginErrorCodes.loginDisabledOasisDown,
			BankIdLoginErrorCodes.authFailedOrNotCompleted,
			BankIdLoginErrorCodes.widgetInitFailed,
			BankIdLoginErrorCodes.userWithPINNotRegistered,
			BankIdLoginErrorCodes.userDataDoesNotMatch,
			BankIdLoginErrorCodes.sessionAlreadyUsed,
			BankIdLoginErrorCodes.authResponseNotValid,
			BankIdLoginErrorCodes.multipleUsersWithPINDetected,
			BankIdLoginErrorCodes.userRegisteredWithoutBankId,
		].includes(errorCode)
	) {
		return (
			<div className="form__group">
				<div className="row">
					<div className="col col-sml-12">
						<InfoMessageComponent
							type="danger"
							message={t<string>(loginError?.message!)}
						/>
					</div>
				</div>
			</div>
		);
	} else if (errorCode == LoginErrorCodes.temporaryLockCode) {
		return (
			<div className="form__group">
				<div className="row">
					<div className="col col-sml-12">
						<InfoMessageComponent
							type="danger"
							message={t<string>(
								`ERR_HANDLING.${loginError?.message}`,
								{
									0: loginError?.errorDuration,
									1: loginError?.errorFailedAttempts,
								}
							)}
						/>
					</div>
				</div>
			</div>
		);
	} else if (errorCode == LoginErrorCodes.temporaryLockedWithDurationCode) {
		return (
			<div className="form__group">
				<div className="row">
					<div className="col col-sml-12">
						<InfoMessageComponent
							type="danger"
							message={t<string>(
								`ERR_HANDLING.${loginError?.message}`,
								{
									0: loginError?.errorFailedAttempts,
									1: loginError?.errorDuration,
								}
							)}
						/>
					</div>
				</div>
			</div>
		);
	} else if (errorCode == LoginErrorCodes.dataConfirmationRequiredCode) {
		return (
			<div className="form__group">
				<div className="row">
					<div className="col col-sml-12">
						<InfoMessageComponent
							type="danger"
							message={t<string>(
								`USER.POPUPS.DATA_CONFIRMATION.USER_DATA_CONFIRMATION_REQUIRED`,
								{
									0: loginError?.message,
								}
							)}
						/>
					</div>
				</div>
			</div>
		);
	} else if (errorCode == LoginErrorCodes.organizationalStructureDisabled) {
		return (
			<div className="form__group">
				<div className="row">
					<div className="col col-sml-12">
						<InfoMessageComponent
							type="danger"
							message={t<string>(
								`ERR_HANDLING.ORGANIZATIONAL_STRUCTURE_DISABLED`,
								{
									0: errorCode,
								}
							)}
						/>
					</div>
				</div>
			</div>
		);
	} else if (errorCode != null) {
		if (errorCode === LoginErrorCodes.userLocked) {
			return (
				<div className="form__group">
					<div className="row">
						<div className="col col-sml-12">
							<InfoMessageComponent
								type="danger"
								message={t<string>(
									`specific:MEMBERSHIP.LOGIN.ERR_HANDLING.${loginError?.message}`
								)}
								isMarkdown={true}
							/>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className="form__group">
				<div className="row">
					<div className="col col-sml-12">
						<InfoMessageComponent
							type="danger"
							message={t<string>(
								`ERR_HANDLING.${loginError?.message}`
							)}
						/>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="form__group">
			<div className="row">
				<div className="col col-sml-12">
					<InfoMessageComponent
						type="danger"
						message={t<string>(`ERR_HANDLING.GENERIC_ERROR`)}
					/>
				</div>
			</div>
		</div>
	);
}
